<script>
import { Bar } from "vue-chartjs";

export default {
  props: {
    groupA: Number,
    groupB: Number,
    yourPrice: String,
    total: Number,
    group: String
  },
  extends: Bar,
  data: function() {
    return {
      chartdata: {
        labels: [
          `Group A (n=${Math.round(this.total / 2)})`,
          `Group B (n=${Math.round(this.total / 2)})`,
          `Your Guess (${this.group})`
        ],
        datasets: [
          {
            backgroundColor: ["#0a0d3d", "#0a0d3d", "#636383"],
            data: [this.groupB, this.groupA, this.yourPrice]
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                callback: function(value) {
                  return "€" + value;
                },
                beginAtZero: true
              },
              gridLines: {
                display: false
              }
            }
          ]
        }
      }
    };
  },
  mounted() {
    this.renderChart(this.chartdata, this.options);
  }
};
</script>
